import { render, staticRenderFns } from "./CryptoWidget.vue?vue&type=template&id=400487a4&"
import script from "./CryptoWidget.vue?vue&type=script&lang=ts&"
export * from "./CryptoWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports